import { useMutation } from "react-query";
import axios from "../axios";
import { LupaPasswordResponse } from "../../constants/types";

const resetPassword = async (formData: FormData) => {
    const response = await axios.post<LupaPasswordResponse>(
        "/api/prosesgantipass",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
    );
    return response.data;
};

export default function useResetPassword() {
    return useMutation((formData: FormData) => resetPassword(formData));
}
